import { ReferenceApi } from "@/shared/components/reference/reference-api";
import { FAQ_URL } from "@/shared/config/constants";

export class ReferenceService {
  private referenceApi = new ReferenceApi();

  /**
   * FAQリンクへ環境ごとの遷移
   * @param {string} referenceCode 参照コード
   */
  public async moveFAQLink(referenceCode: string) {
    // NOTE:safariでは、API実行後の別タブ画面遷移をopen関数ではできません。

    // ブラウザでは一度ブランクの別タブを出し、API実行し、ブランクの別タブにURLを設定することで実現可能
    const openWindow = open("", "_blank");
    const uri = await this.getFAQLink(referenceCode);
    if (openWindow) {
      openWindow.location.href = uri;
    }
  }

  /**
   * FAQリンク取得API実行
   * @param {string} referenceCode 参照コード
   */
  public async getFAQLink(referenceCode: string): Promise<string> {
    try {
      const response = await this.referenceApi.get(referenceCode);
      return response.uri;
    } catch (error) {
      // APIに失敗した場合は、FAQのトップページを設定
      return FAQ_URL;
    } finally {
      // intentionally empty
    }
  }
}
